import React from 'react';
import { useSelector } from 'react-redux';
import AuthButton from '../components/AuthButton';

function AuthButtonContainer(props) {
  const authentication = useSelector((state) => state.authentication);
  const { status = '' } = authentication;
  const name = authentication.user?.name;

  return <AuthButton {...props} status={status} name={name} />;
}

export default AuthButtonContainer;
